import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { Storage } from '@app/plugins/storage';
import { shared } from '@shared/store';
import { core } from '@core/store';
import { prices } from '@prices/store';
import { mailer } from '@mailer/store';
import { db } from '@db/store';
import { call_tracking } from '@call-tracking/store';
import { phone_number } from '@phone-number/store';
import { referral } from '@referral/store';
import { verification } from '@verification/store';
import { voice } from '@voice/store';
import { autoinformer } from '@autoinformer/store';
import { autocaller_v2 } from '@autocaller_v2/store';
import { notify } from '@notify/store';
import { pbx } from '@pbx/store';
import { amo_widget } from '@amo-widget/store';
import { hlr } from '@hlr/store';

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  modules: {
    shared,
    core,
    prices,
    mailer,
    db,
    referral,
    verification,
    voice,
    autoinformer,
    autocaller_v2,
    notify,
    pbx,
    'call-tracking': call_tracking,
    'phone-number': phone_number,
    amo_widget,
    hlr
  },
  plugins: [
    createPersistedState({
      paths: ['core.auth'],
      key: 'zorra-cabinet-store',
      storage: {
        getItem: (key) => Storage.get(key),
        setItem: (key, value) => Storage.set(key, value),
        removeItem: (key) => Storage.remove(key)
      }
    })
  ]
});
